@if (isEnabled && !isUnset) {
  <mat-icon class="icon enabled" matTooltip="{{matTooltip}}">check_circle</mat-icon>
}
@if (!isEnabled && !isUnset) {
  <mat-icon class="icon disabled" matTooltip="{{matTooltip}}">cancel</mat-icon>
}
@if (isUnset) {
  <mat-icon class="icon unset" matTooltip="{{matTooltip}}">remove_circle</mat-icon>
}
@if (matTooltip) {
  <span class="cdk-visually-hidden">{{ matTooltip }}</span>
}
